import * as React from "react";
import { connect } from "react-redux";
import { DoFlashlightSearch, getAllCounties } from "./redux-objects/actions";
import DataTable from "../DataTable";
import moment from "moment";
import Form from "react-bootstrap/Form";
import Col from "react-bootstrap/Col";
import { Button } from "react-bootstrap";
import dateFnsFormat from "date-fns/format";
import "react-dates/initialize";
import "react-dates/lib/css/_datepicker.css";
import ReactDOM from "react-dom";
import { Provider } from "react-redux";
import * as urls from "../shared/urls";
import { IFlashlightSearchResponse } from "./business-objects/types";
import Select from "react-select";
import { getTableValuesByGroupName } from "../../services/Utils/IndexedDBUtils";
import RBSelectList from "../RBSelectList/RBSelectList";
import { getAllAgencies } from "../ThirdPartyVendors/redux-objects/actions";
import { AgencyInfo } from "../Forms/Keywords/business-objects/common";
import "./assets/FlashlightSearch.scss";
import { isGranted, permissions } from "../../services/permissionChecker";
import { UserInfo } from "../Login/common/defaults";
import ViewAllButton from "../DocumentViewer/ViewAllButton";
import Store from "../../store/Store";
import rootReducer from "../../store/Reducers";
import DateRangePicker from '@wojtekmaj/react-daterange-picker';
import { CountyInfo } from "../WorkflowQueues/Keywords/business-objects/common";

const reduxStore = Store({}, rootReducer);

const $ = require("jquery");
$.DataTable = require("datatables.net-bs4");

export interface IFlashlightSearchActionProps {
  DoFlashlightSearch?: (url: string, request: any) => Promise<void>;
  getAllAgencies: (url: string) => Promise<void>;
  getAllCounties: (url: string) => Promise<void>;
}

export const injuryStatusOptions = [
  { value: 1, label: "PDO" },
  { value: 2, label: "INJURY" },
  { value: 3, label: "FATAL" }
];

interface IFlashlightSearchStateProps {
  webServiceURL: string;
  searchResults: IFlashlightSearchResponse;
  allAgencies: AgencyInfo[];
  currentUser: UserInfo;
  counties: CountyInfo[],
}

interface IFlashlightSearchProps
  extends IFlashlightSearchActionProps,
  IFlashlightSearchStateProps { }

const initialState = {
  focusedInput: null,
  crashKey: "",
  isGetingImage: false,
  countyId: "",
  countyOption: {},
  injury: "",
  isSearching: false,
  searchMessage: "",
  startDate: null,
  endDate: null,
  agencyId: null,
  firstName: "",
  lastName: "",
  businessName: "",
  agencyCaseNumber: "",
  searchExactNameOnly: false,
  dbToSearch: "private",
  drp: [null, null]
};
type FlashlightSearchState = Readonly<typeof initialState>;
class FlashlightSearch extends React.Component<
  IFlashlightSearchProps,
  FlashlightSearchState
> {
  public constructor(props: IFlashlightSearchProps) {
    super(props);
    this.state = initialState;
  }

  componentDidMount() {
    if (!this.props.counties || this.props.counties.length === 0) {
      this.props.getAllCounties(urls.GET_ALL_COUNTIES);
    }
    if (!this.props.allAgencies || this.props.allAgencies.length == 0) {
      this.props.getAllAgencies(urls.GET_ALL_AGENCIES);
    }
  }
  handleClear(e: React.MouseEvent<HTMLElement>) {
    this.setState(
      {
        crashKey: "",
        countyId: "",
        countyOption: {},
        injury: "",
        startDate: null,
        endDate: null,
        agencyId: null,
        firstName: "",
        lastName: "",
        businessName: "",
        agencyCaseNumber: "",
        drp: [new Date().toDateString(), new Date().toDateString()]
      }, () => {
        this.setState({ drp: [null, null] })
      });
  }
  handleSearchButton(event: React.MouseEvent<HTMLElement>) {
    this.setState(
      { ...this.state, isSearching: true, searchMessage: "Searching..." },
      () => {
        const crashDateStart = this.state.drp && this.state.drp.length > 1 && this.state.drp[0] && this.state.drp[0].toDateString() || null;
        const crashDateEnd = this.state.drp && this.state.drp.length > 1 && this.state.drp[1] && this.state.drp[1].toDateString() || null;
        var request = {
          crashKey: this.state.crashKey,
          injury: injuryStatusOptions.find(
            (o) => o.value.toString() === this.state.injury
          )?.label,
          county: this.state.countyId,
          crashDateStart,
          crashDateEnd,
          agencyId: this.state.agencyId,
          firstName: this.state.firstName,
          lastName: this.state.lastName,
          businessName: this.state.businessName,
          agencyCaseNumber: this.state.agencyCaseNumber,
          searchExactNameOnly: this.state.searchExactNameOnly,
          dbToSearch: this.state.dbToSearch
        };
        this.props
          .DoFlashlightSearch(
            this.props.webServiceURL + urls.SIMPLE_SEARCH,
            request
          )
          .then(() =>
            this.setState({
              ...this.state,
              isSearching: false,
              searchMessage: ""
            })
          );
      }
    );
  }

  handleCountyChange = (e: any) => {
    if (e == null) e = "";
    this.setState({
      countyId: e.value,
      countyOption: e
    });
  };

  handleInjuryStatusChange = (e: { label: string, value: string }, action: { action: string }) => {
    console.log({ e, action })
    if (action.action === "clear") {
      this.setState({
        injury: "",
      });
    }
    else {
      this.setState({
        injury: e.value.toString(),
      })
    }
  }

  handleChange = (e: React.FormEvent) => {
    let el: HTMLFormElement = e.currentTarget as HTMLFormElement;

    switch (el.dataset.field) {
      case "crashKey":
        this.setState({
          crashKey: el.value
        });
        break;
      case "firstName":
        this.setState({
          firstName: el.value
        });
        break;
      case "lastName":
        this.setState({
          lastName: el.value
        });
        break;
      case "businessName":
        this.setState({
          businessName: el.value
        });
        break;
      case "injury":
        this.setState({
          injury: el.value
        });
        break;
      case "agencyCaseNumber":
        this.setState({
          agencyCaseNumber: el.value
        });
        break;
      case "searchExactNameOnly":
        this.setState({
          searchExactNameOnly: (e.target as HTMLInputElement).checked
        });
        break;
      case "dbToSearch":
        this.setState({
          dbToSearch: el.value
        });
        break;
      default:
        break;
    }
  };

  public render() {
    const columnDefs = [
      {
        targets: 0,
        width: "150px",
        createdCell: (td, cellData, rowData, row, col) =>
          ReactDOM.render(
            <div>
              <Provider store={reduxStore}>
                <ViewAllButton
                  reportId={rowData?.reportId}
                  dbToSearch={this.state.dbToSearch}
                />
              </Provider>
            </div>,
            td
          )
      },
      {
        targets: 1,
        render: function (data) {
          return moment(data).format("MM/DD/YYYY");
        }
      },
      {
        targets: 4,
        width: "150px",
        createdCell: (td, cellData, rowData) =>
          ReactDOM.render(
            <ul>
              {[
                ...new Set(
                  (rowData?.involvedParties || [])
                    .map((x) => {
                      return [x.lastName, x.firstName, x.businessName]
                        .filter(Boolean)
                        .join(", ");
                    })
                    .sort()
                )
              ].map((x, index) => {
                return <li key={index}>{x}</li>;
              })}
            </ul>,
            td
          )
      }
    ];

    const columns = [
      {
        title: "",
        data: "reportId"
      },
      {
        title: "Crash Date",
        data: "crashDate"
      },
      {
        title: "Crash Key",
        data: "crashKey"
      },
      {
        title: "Document ID",
        data: "documentId"
      },
      {
        title: "Names",
        mData: function (data) {
          return data?.involvedParties || "";
        }
      },
      {
        title: "Injury Status",
        data: "injury"
      },
      {
        title: "County",
        data: "county"
      }
    ];
    const options = {
      dom: "frtipB"
    };
    const agencyList = this.props.allAgencies.map((agency) => ({
      label: agency.name,
      value: agency.id
    }));

    const onAgencyChange = (value, action) => {
      if (action.action != "clear") {
        this.setState({ agencyId: value.value });
      } else if (action.action == "clear") {
        this.setState({ agencyId: null });
      }
    };

    const onChangeDate = (newDrp: Date[]) => {
      this.setState({ drp: newDrp });
    }

    return (
      <div className="app">
        <div className="row">
          <div className="col-sm-6">
            <h3>Report Search</h3>
          </div>
        </div>

        <hr />
        <Form>
          <Form.Row>
            <Form.Group as={Col} controlId="flashlightSearchsStartDate">
              <Form.Label>Crash Date</Form.Label>
              <br />
              <DateRangePicker
                onChange={onChangeDate}
                value={this.state.drp}
                rangeDivider=" to "
                openCalendarOnFocus={false}
                clearIcon={null}
                maxDate={new Date(2100, 12, 12)}
              />

            </Form.Group>

            <Form.Group as={Col} controlId="exampleForm.ControlSelect1">
              <Form.Label>Crash Key</Form.Label>
              <Form.Control
                data-field="crashKey"
                type="text"
                value={this.state.crashKey}
                onChange={(e) => this.handleChange(e)}
              />
            </Form.Group>

            <Form.Group as={Col} className="selectlist">
              <Form.Label>Injury Status</Form.Label>
              <Select
                data-field="injury"
                placeholder=""
                options={injuryStatusOptions}
                onChange={this.handleInjuryStatusChange}
                value={injuryStatusOptions.find(i => i.value.toString() === this.state.injury) || ""}
                isClearable={true}
              />
            </Form.Group>
            <Form.Group as={Col} controlId="exampleForm.ControlSelect1133">
              <Form.Label>Agency Case Number</Form.Label>
              <Form.Control
                data-field="agencyCaseNumber"
                type="text"
                value={this.state.agencyCaseNumber}
                onChange={(e) => this.handleChange(e)}
              />
            </Form.Group>
            {this.props.counties && this.props.counties.length > 0 && (
              <Form.Group as={Col} className="selectlist">
                <Form.Label>County</Form.Label>
                <Select
                  data-field="county"
                  placeholder=""
                  options={this.props.counties.map((county) => ({
                    label: county.name + " - " + county.description,
                    value: county.name + " - " + county.description
                  }))}
                  onChange={(e) => this.handleCountyChange(e)}
                  value={this.state.countyOption}
                  isClearable={true}
                />
              </Form.Group>
            )}{!(this.props.counties && this.props.counties.length > 0) && (
              <Form.Group as={Col} className="selectlist">
                <Form.Label>Loading Counties</Form.Label>                
              </Form.Group>
            )}
          </Form.Row>
          <Form.Row>
            <Form.Group as={Col} controlId="exampleForm.ControlSelect11">
              <Form.Label>First Name</Form.Label>
              <Form.Control
                data-field="firstName"
                type="text"
                value={this.state.firstName}
                onChange={(e) => this.handleChange(e)}
              />
              <Form.Check
                data-field="searchExactNameOnly"
                onChange={(e) => this.handleChange(e)}
                type="checkbox"
                label="Exact name match"
                checked={this.state.searchExactNameOnly}
                style={{ marginLeft: 0 }}
              />
            </Form.Group>
            <Form.Group as={Col} controlId="exampleForm.ControlSelect112">
              <Form.Label>Last Name</Form.Label>
              <Form.Control
                data-field="lastName"
                type="text"
                value={this.state.lastName}
                onChange={(e) => this.handleChange(e)}
              />
            </Form.Group>
            <Form.Group as={Col} controlId="exampleForm.ControlSelect113">
              <Form.Label>Business Name</Form.Label>
              <Form.Control
                data-field="businessName"
                type="text"
                value={this.state.businessName}
                onChange={(e) => this.handleChange(e)}
              />
            </Form.Group>
            <Form.Group as={Col} className="selectlist">
              <Form.Label>Agency</Form.Label>
              <Select
                placeholder=""
                options={agencyList}
                onChange={(value, action) => {
                  onAgencyChange(value, action);
                }}
                value={
                  agencyList.filter((x) => x.value == this.state.agencyId)[0] ||
                  ""
                }
                isClearable={true}
              />
            </Form.Group>
            <Col></Col>
          </Form.Row>
          <Form.Row>
            <Form.Group as={Col} controlId="searchButton">
              <div className="">
                <Button
                  disabled={this.state.isSearching}
                  onClick={(e) => this.handleSearchButton(e)}
                  className="mr-2"
                >
                  {this.state.isSearching && (
                    <div>
                      {this.state.searchMessage}{" "}
                      <img
                        height="30px"
                        src={require("../../../src/assets/SmartAdmin/img/flashlight.gif")}
                      />
                    </div>
                  )}
                  {!this.state.isSearching && <div>Search</div>}
                </Button>
                <Button
                  onClick={(e) => this.handleClear(e)}
                  className="mr-2"
                >
                  <div>Clear</div>
                </Button>
                <select
                  onChange={(e) => this.handleChange(e)}
                  style={{
                    height: "40px",
                    marginRight: "10px",
                    position: "relative",
                    top: "0px"
                  }}
                  data-field="dbToSearch"
                  defaultValue={this.state.dbToSearch}
                >
                  {isGranted(
                    permissions.FlashlightSearchPrivate,
                    this.props.currentUser
                  ) && <option value="private">Private</option>}
                  {isGranted(
                    permissions.FlashlightSearchPublic,
                    this.props.currentUser
                  ) && <option value="public">Public</option>}
                </select>
              </div>
            </Form.Group>
          </Form.Row>
          <Form.Row />
        </Form>
        {!this.state.isSearching && this.props.searchResults != null && (
          <DataTable
            id="tblFlashlightSearchs"
            data={this.props.searchResults.results}
            columns={columns}
            columnDefs={columnDefs}
            actionsColumn="first"
            select={false}
            {...options}
          />
        )}
      </div>
    );
  }
}

export function mapStateToProps(state: any) {
  return {
    webServiceURL: state.Application.backendURL,
    searchResults: state.FlashlightSearch.response,
    allAgencies: state.Vendors.allAgencies,
    counties: state.FlashlightSearch.counties,
    currentUser: state.Application.currentUser
  };
}

const mapDispatchToProps = {
  DoFlashlightSearch,
  getAllAgencies,
  getAllCounties  
};

export default connect(mapStateToProps, mapDispatchToProps)(FlashlightSearch);
